// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden-value-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;  
}

.hidden-value-input-wrapper .hidden-icon{
  display:none;
}

.hidden-input-with-icon {
  padding-right: 35px !important;
}

.reveal-icon-btn-inside {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #666;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.reveal-icon-btn-inside:hover {
  color: #333;
}

.reveal-icon-btn-inside mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/sem-text-box/sem-text-box.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd","sourcesContent":[".hidden-value-input-wrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;  \r\n}\r\n\r\n.hidden-value-input-wrapper .hidden-icon{\r\n  display:none;\r\n}\r\n\r\n.hidden-input-with-icon {\r\n  padding-right: 35px !important;\r\n}\r\n\r\n.reveal-icon-btn-inside {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  color: #666;\r\n  transition: color 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 2;\r\n}\r\n\r\n.reveal-icon-btn-inside:hover {\r\n  color: #333;\r\n}\r\n\r\n.reveal-icon-btn-inside mat-icon {\r\n  font-size: 18px;\r\n  width: 18px;\r\n  height: 18px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
